import { Card, CardBody, Col, Container, Input, Label, Row, Table, Pagination, PaginationItem, PaginationLink, CardHeader } from "reactstrap";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useEffect, useState } from "react";
import { SearchTableButton } from "../../utils/Constant";
import { URL_API } from "../../utils/helper/helpers";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useParams } from "react-router-dom";
import { Badges, H5, H6 } from "../../AbstractElements";
import { formatDate, formatPhoneNumber, formatPrice, truncateText } from "../../utils/helper/helpers";
import { CardFooter } from 'reactstrap';

type Produit = {
    libelle: string;
    prix_unitaire: number;
    quantite_stock: number;
    unite_de_mesure: string;
    valeur_par_tonnes: number;
    // total_montant_entree: number;
    // total_quantite_entree: number;
    // total_montant_sortie: number;
    // total_quantite_sortie: number;
    status: string;
};

interface Detail {
    date: string;
    type: string;
    quantite: number;
    prix_unitaire?: number;
    prix_total?: number;
    description?: string;
}

interface Mouvement{
    created_at: string;
    date_mouvement: string;
    description: string;
    id: number
    produit_id: number
    quantite: number;
    type_mouvement: string;
    updated_at: string;
    user_id: number;
}

const ShowProduits = () => {
    const { id } = useParams<{ id: string }>();
    const [filterText, setFilterText] = useState("");
    const [filteredVentes, setFilteredVentes] = useState<Mouvement[]>([]);
    const [produit, setProduit] = useState<Produit | null>(null);
    // const [details, setDetails] = useState<Detail[]>([]);
    const [mouvement, setMouvemeent] = useState<Mouvement[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [filter, setFilter] = useState<string>('all');
    const [typeFilter, setTypeFilter] = useState<string>('all'); // État pour le filtre par type
    const [startDate, setStartDate] = useState<string>('');
    const [endDate, setEndDate] = useState<string>('');
    const Token = JSON.parse(localStorage.getItem("login")!);

    // Pagination states
    const [currentPage, setCurrentPage] = useState<number>(1);
    const itemsPerPage = 10;

    const filterDetails = () => {
        const today = new Date();
        const startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - today.getDay());
        const endOfWeek = new Date(today);
        endOfWeek.setDate(today.getDate() + (6 - today.getDay()));
        const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        const start = startDate ? new Date(startDate) : null;
        const end = endDate ? new Date(endDate) : null;
        // console.log('mouvement',mouvement)
        const filtered = Array.isArray(mouvement) ? mouvement.filter(item => {
            const itemDate = new Date(item.created_at);
            let dateMatch = true; // Par défaut, on considère que la date correspond
            let typeMatch = true; // Par défaut, on considère que le type correspond
            let searchMatch = true; // Par défaut, on considère que la recherche correspond
        // console.log('Gabriel jp', mouvement);

            // Vérifiez la correspondance de date
            switch (filter) {
                case 'today':
                    dateMatch = itemDate.toDateString() === today.toDateString();
                    break;
                case 'week':
                    dateMatch = itemDate >= startOfWeek && itemDate <= endOfWeek;
                    break;
                case 'month':
                    dateMatch = itemDate >= startOfMonth && itemDate <= endOfMonth;
                    break;
                case 'interval':
                    dateMatch = start !== null && end !== null && itemDate >= start && itemDate <= end;
                    break;
                default:
                    dateMatch = true;
            }

            // Filtre par type
            if (typeFilter !== 'all') {
                typeMatch = item.type_mouvement === typeFilter;
            }

            // Filtre par recherche
            if (filterText) {
                searchMatch = item.description?.toLowerCase().includes(filterText.toLowerCase()) || false;
            }

            return dateMatch && typeMatch && searchMatch; // Retournez le résultat de la vérification
        }) : [];
        // console.log('filtered jp', filtered)
        setFilteredVentes(filtered);
    }
    useEffect(() => {
        const fetchProduit = async () => {
            try {
                const response = await axios.get(`${URL_API}/produit/get/${id}`, {
                    headers: {
                        Authorization: `Bearer ${Token}`
                    }
                });

                if (response.data.success) {
                    // console.log(response.data);
                    setProduit(response.data.produit);
                    // setDetails(response.data.details);
                    setMouvemeent(response.data.mouvement);
                }
            } catch (error: any) {
                if (error.response && !error.response.data.success) {
                    toast.info(error.response.data.message);
                } else {
                    toast.error("Erreur lors du chargement du produit.");
                }
                setError("Erreur lors du chargement du produit.");
            } finally {
                setLoading(false);
            }
        };
        fetchProduit();
    }, [id]);

    useEffect(() => {
        filterDetails();
    }, [mouvement, filter, startDate, endDate, typeFilter, filterText]); // Ajoutez filterText ici

    // Handle pagination
    const totalPages = Math.ceil(filteredVentes.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredVentes.slice(indexOfFirstItem, indexOfLastItem);

    // console.log('mouvement final', filteredVentes);


    const paginate = (pageNumber: number) => setCurrentPage(pageNumber);
    if (loading) return <p>Chargement...</p>;
    if (error) return <p>{error}</p>;
    console.log(produit);
    let stock_final = 0.00;
    return (
        <div className='page-body'>
            <Breadcrumbs mainTitle="Details" parent="Produits" />
            <Container fluid>
                <Row>
                    <Col md="12">
                        <Card>
                            <CardBody>
                                <Table bordered striped={true} responsive className="text-center">
                                    <thead>
                                        <tr className="bg-primary">
                                            <th scope="col" className="text-white">NOM</th>
                                            <th scope="col" className="text-white">PRIX UNITAIRE</th>
                                            <th scope="col" className="text-white">QUANTITE STOCK</th>
                                            <th scope="col" className="text-white">STATUS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {produit && (
                                            <tr >
                                                <td className="py-3">{produit.libelle}</td>
                                                <td>{formatPrice(produit.prix_unitaire)} / {produit.unite_de_mesure}</td>
                                                <td>{produit.quantite_stock} / {produit.unite_de_mesure}</td>
                                                <td>
                                                    {produit.status === 'disponible' ? (
                                                        <Badges color="light-success">{produit.status}</Badges>
                                                    ) : (
                                                        <Badges color="light-danger">{produit.status}</Badges>
                                                    )}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardBody>
                                <div className="filter-section">
                                    <Row>
                                        <Col sm="6">
                                            <Label for="filter">Filtre Date :</Label>
                                            <Input
                                                type="select"
                                                className="form-control"
                                                id="filter"
                                                value={filter}
                                                onChange={(e) => setFilter(e.target.value)}
                                            >
                                                <option value="all">Tous</option>
                                                <option value="today">Aujourd'hui</option>
                                                <option value="week">Cette semaine</option>
                                                <option value="month">Ce mois</option>
                                                <option value="interval">Intervalle de dates</option>
                                            </Input>
                                        </Col>
                                        <Col sm="6">
                                            <Label for="typeFilter">Filtre Type :</Label>
                                            <Input
                                                type="select"
                                                className="form-control"
                                                id="typeFilter"
                                                value={typeFilter}
                                                onChange={(e) => setTypeFilter(e.target.value)}
                                            >
                                                <option value="all">Tous</option>
                                                <option value="approvisionnement">Approvisionnement</option>
                                                <option value="vente">Vente</option>
                                            </Input>
                                        </Col>
                                    </Row>
                                </div>
                            </CardBody>
                        </Card>

                        {filter === "interval" && (
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col sm={6}>
                                            <Label for="startDate">Début :</Label>
                                            <Input
                                                type="date"
                                                id="startDate"
                                                value={startDate}
                                                onChange={(e) => setStartDate(e.target.value)}
                                            />
                                        </Col>
                                        <Col sm={6}>
                                            <Label for="endDate">Fin :</Label>
                                            <Input
                                                type="date"
                                                id="endDate"
                                                value={endDate}
                                                onChange={(e) => setEndDate(e.target.value)}
                                            />
                                        </Col>
                                    </Row>

                                </CardBody>
                            </Card>
                        )}

                        <Card>
                            <CardBody>
                                <Row>
                                    <Col sm="12">
                                        <div className="dataTables_filter d-flex align-items-center">
                                            <Label className="me-2">{SearchTableButton}:</Label>
                                            <Input
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                                                type="search"
                                                value={filterText}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>

                            <div className="d-flex justify-content-between w-100 bg-primary py-2 ">

                                {/* TITRE */}
                                <div className="d-flex justify-content-between gap-2 w-50 ps-2 ">
                                    <h5 className="text-uppercase text-white fw-bold">FICHE DE STOCK {produit?.libelle}</h5>

                                    <h5 className="text-uppercase text-white fw-bold">
                                        {produit && (
                                            <>
                                                {produit.valeur_par_tonnes + " " + produit.unite_de_mesure + " / "}
                                                {produit.valeur_par_tonnes === 1
                                                    ? produit.unite_de_mesure
                                                    : produit.valeur_par_tonnes === 5
                                                    ? "Paquets"
                                                    : "Tonnes"}
                                            </>
                                        )}
                                    </h5>
                                </div>

                                {/* QUANTITÉ */}
                                <div className="w-25">
                                    <h5 className="text-center text-white fw-bold">MOUVEMENT</h5>
                                </div>

                                {/* STOCK */}
                                <div className="w-25">
                                    <h5 className="text-center text-white fw-bold">STOCK</h5>
                                </div>

                            </div>

                            <div className={`theme-scrollbar table-responsive table table-striped text-center`}>

                                <Table size={'sm'} responsive={"sm"} striped={true} hover>
                                    <thead className={`tbl-strip-thad-bdr border bg-primary`}>
                                        <tr className="border">
                                            {/* <th scope="col" className="border">#Id</th> */}
                                            <th scope="col" className=" border text-white text-uppercase">Date</th>
                                            <th scope="col" className=" border text-white text-uppercase">Designation</th>
                                            <th scope="col" className=" border text-white text-uppercase">Unite</th>
                                            {/* <th scope="col" className=" border text-white text-uppercase">Stock Init</th> */}
                                            <th scope="col" className=" border text-white text-uppercase">Entrée</th>
                                            <th scope="col" className=" border text-white text-uppercase">Sortie</th>
                                            <th scope="col" className=" border text-white text-uppercase">Stock Final</th>
                                            <th scope="col" className="border text-white text-uppercase">{produit?.valeur_par_tonnes === 5 ? 'Paquets' : 'Tonnes'}</th>
                                        
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItems.map((item, index) => {
                                            if(item.type_mouvement === 'entree'){
                                                stock_final +=  Number(item.quantite)
                                            }else if(item.type_mouvement === 'sortie'){
                                                stock_final -= Number(item.quantite)
                                            }
                                            return (
                                                <tr key={index} className='text-center'>
                                                    <td style={{ textAlign: "center" }}>
                                                        <span className={` ${item.type_mouvement === 'entree' ? 'fw-bold' : ''} text-dark text-capitalize`}>
                                                            {formatDate(new Date(item.date_mouvement))}
                                                        </span>
                                                    </td>
                                                    <td style={{ textAlign: "center" }}>
                                                        <span className={` ${item.type_mouvement === 'entree' ? 'fw-bold' : ''} text-dark text-capitalize`}>
                                                            {item.description}
                                                        </span>
                                                    </td>
                                                    <td style={{ textAlign: "center" }}>
                                                        <span className={` ${item.type_mouvement === 'entree' ? 'fw-bold' : ''} text-dark text-capitalize`}>
                                                            {produit?.unite_de_mesure}
                                                        </span>
                                                    </td>
                                                    <td style={{ textAlign: "center" }}>
                                                        <span className={` ${item.type_mouvement === 'sortie' ? 'text-danger' : 'text-success fw-bold' } text-capitalize`}>
                                                            { item.type_mouvement === 'entree' ? Number(item.quantite).toLocaleString("gn-GN") : '-' }
                                                        </span>
                                                    </td>
                                                    <td style={{ textAlign: "center" }}>
                                                        <span className={` ${item.type_mouvement === 'sortie' ? 'text-danger' : 'text-success fw-bold' } text-capitalize`}>
                                                            { item.type_mouvement === 'sortie' ? Number(item.quantite).toLocaleString("gn-GN") : '-'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className={` ${item.type_mouvement === 'sortie' ? 'text-danger' : 'text-success fw-bold' } text-capitalize`}>
                                                            {stock_final}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className={` ${item.type_mouvement === 'sortie' ? 'text-danger' : 'text-success fw-bold' } text-capitalize`}>
                                                            {produit && produit?.valeur_par_tonnes > 1 ? (Number(stock_final) / Number(produit.valeur_par_tonnes)).toFixed(2) : '-'}
                                                        </span>
                                                    </td>
                                                    
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>

                            </div>
                            {totalPages > 1 && (
                                <CardFooter>
                                    <Pagination>
                                        {[...Array(Math.ceil(filteredVentes.length / itemsPerPage))].map((_, i) => (
                                            <PaginationItem key={i} active={i + 1 === currentPage}>
                                                <PaginationLink onClick={() => paginate(i + 1)}>
                                                    {i + 1}
                                                </PaginationLink>
                                            </PaginationItem>
                                        ))}
                                    </Pagination>
                                </CardFooter>
                            )}
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>

    );
};

export default ShowProduits;
